<template>
    <div>
        <ul v-if="!!errors" class="text-danger mb-0"><li v-for="(error,index) in errors" :key="index"><span>{{ this.getTranslatedText(error, 'validations') }}</span></li></ul>
    </div>
</template>

<script>

import {inject} from "vue";

export default {
    name: "LcFieldErrors",
    props: {
        errors: {
            type: Array,
            required: false,
            default: []
        },
    },
    setup(props) {
        const { getTranslatedText } = inject('app') // app is being provided in Application.vue
        return {
            getTranslatedText
        }
    }
}
</script>

<style scoped>

</style>
